module.exports = __webpack_public_path__ + "img/rejectPayment.4a3c700a.svg";